import { Box, type BoxProps, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Link } from "@tanstack/react-router";
import type { TheFooterProps } from "../model/types";

export type TheFooterUIProps = TheFooterProps & BoxProps;

export const TheFooter = ({ footerLinks, ...props }: TheFooterUIProps) => {
  return (
    <Box
      component="footer"
      display="flex"
      flexDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
      p={4}
      mt="auto"
      bgcolor={grey[50]}
      {...props}
    >
      {footerLinks.map((link) => (
        <Box
          component={Link}
          key={link.label}
          to={link.href}
          target="_blank"
          sx={{
            color: grey[600],
            fontSize: "12px",
            fontWeight: 400,
            textDecoration: "none",
          }}
        >
          {link.label}
        </Box>
      ))}
      <Typography
        fontSize="12px"
        fontWeight={400}
        color={grey[600]}
        sx={{
          flexGrow: { xs: 0, sm: 1 },
          textAlign: { xs: "left", sm: "right" },
        }}
      >
        © X Mile, Inc.
      </Typography>
    </Box>
  );
};
